class AboutPage {
	constructor(container) {
		this.container = container
		this.imageIndicator = this.container.querySelector('.about-images-indicator')
		this.images = this.container.querySelectorAll('.about-images-section-right div img')

		this.imageAnimation()
		this.iframeAnimation()
	}

	imageAnimation() {
		this.duration = 10
		this.repeatDelay = 0.35
		this.ease = 'none'

		gsap.to(this.imageIndicator, {
			left: '100%',
			duration: this.duration,
			ease: this.ease,
			repeat: -1,
			repeatDelay: this.repeatDelay,
		})

		const tl = gsap.timeline({
			defaults: { ease: this.ease },
			repeat: -1,
			repeatDelay: this.repeatDelay,
		})
		this.images.forEach((element, idx) => {
			tl.to(element, {
				clipPath: 'inset(0% 0% 0% 0%)',
				duration: this.duration / this.images.length,
				startAt: {
					clipPath: 'inset(0% 100% 0% 0%)',
				},
				onStart: () => {
					this.images.forEach((otherElement) => {
						if (otherElement !== element) {
							gsap.to(otherElement, {
								clipPath: 'inset(0% 0% 0% 100%)',
								duration: this.duration / this.images.length,
								ease: this.ease,
							})
						}
					})

					if (idx === 0) {
						gsap.set(this.images[this.images.length - 1], {
							clipPath: 'inset(0% 0% 0% 0%)',
						})
					}
				},
			})
		})
	}

	iframeAnimation() {
		gsap
			.timeline({
				defaults: { ease: 'none' },
				scrollTrigger: {
					trigger: '.about-hero-video',
					scrub: true,
					start: 'top 45%',
					end: 'top 10%',
				},
			})
			.to('.about-hero-video', {
				width: '100%',
			})
			.to(
				'.about-hero h1',
				{
					y: '110%',
				},
				0
			)
		window.addEventListener('resize', () => {
			ScrollTrigger.refresh()
		})
	}
}

document.addEventListener('DOMContentLoaded', function () {
	new AboutPage(document.querySelector('.about'))
})
